import { CookieStorage } from 'cookie-storage';
import { UserManagerSettings, UserManager, WebStorageStateStore } from 'oidc-client-ts';

export interface Settings extends UserManagerSettings {
  // authority: string;
  // client_id: string;
  // redirect_uri: string;
  // post_logout_redirect_uri: string;
  // client_secret: string;
  // response_type: string;
  // scope: string;
}

let userManager: UserManager | null = null;

const userStorage = new CookieStorage({
  path: '/',
  // 1 day
  expires: new Date(Date.now() + 1 * 24 * 60 * 60 * 1000),
  secure: true,
  sameSite: 'Strict',
});

export function configureUserManager(settings: Settings) {
  userManager = new UserManager({
    ...settings,
    userStore: new WebStorageStateStore({ store: userStorage }),
  });
  return userManager;
}

export function getUserManager() {
  return userManager;
}

export async function signInRedirect() {
  if (!userManager) {
    throw new Error('User manager not configured!');
  }
  return userManager.signinRedirect();
}

export async function signInRedirectCallback() {
  if (!userManager) {
    throw new Error('User manager not configured!');
  }
  const user = await userManager.signinRedirectCallback();
  return user;
}

export async function removeUser() {
  if (!userManager) {
    throw new Error('User manager not configured!');
  }
  const user = await userManager.removeUser();
  return user;
}

export async function signinSilent() {
  if (!userManager) {
    throw new Error('User manager not configured!');
  }
  const user = await userManager.signinSilent();
  return user;
}

export async function signOutRedirect() {
  if (!userManager) {
    throw new Error('User manager not configured!');
  }
  return userManager.signoutRedirect();
}

export async function getUser() {
  if (!userManager) {
    throw new Error('User manager not configured!');
  }
  const user = await userManager.getUser();
  return user;
}
